import React from 'react';
import { Helmet } from 'react-helmet-async';

interface StructuredDataProps {
  type?: 'WebApplication' | 'WebSite';
  name?: string;
  description?: string;
  url?: string;
}

const StructuredData: React.FC<StructuredDataProps> = ({ 
  type = 'WebApplication',
  name = 'Gym Planner - Free Weightlifting Planner',
  description = 'Completely free weightlifting and workout planner. Create custom exercises, build workout templates, and track your progress. Perfect for strength training and fitness goals.',
  url = window.location.origin
}) => {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': type,
    name,
    description,
    url,
    applicationCategory: 'HealthApplication',
    operatingSystem: 'WebBrowser',
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'USD',
      description: 'Completely free to use - no subscription or payment required'
    },
    featureList: [
      'Create custom exercises',
      'Build workout templates',
      'Track weightlifting progress',
      'Monitor strength gains',
      'Plan workout routines',
      'Free to use forever'
    ],
    screenshot: `${url}/screenshot.png`,
    author: {
      '@type': 'Organization',
      name: 'Gym Planner'
    },
    aggregateRating: type === 'WebApplication' ? {
      '@type': 'AggregateRating',
      ratingValue: '4.8',
      ratingCount: '1000+',
      bestRating: '5',
      worstRating: '1'
    } : undefined
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default StructuredData;
